import "./loader/MultiInstanceRecoLoader";
import "./carousel/RecoCarousel";
import "./carousel/RecoCarouselContainer";
import "./carousel/RecoCarouselNaviNext";
import "./carousel/RecoCarouselNaviPrev";
import "./../styles/recoContainer.scss";

window.CubeDataLayer = window.CubeDataLayer || [];
